<div
  class="relative inline-flex w-full rounded-full bg-gray-200 p-1 sm:w-auto sm:p-0.5"
>
  <div
    class="absolute top-0.5 bottom-0.5 left-0.5 w-1/2 rounded-full bg-black transition-transform duration-300 ease-in-out"
    [ngClass]="viewType() === 'grid' ? 'translate-x-full' : ''"
  ></div>
  <button
    class="relative z-10 flex w-1/2 items-center justify-center space-x-1 rounded-full px-3 py-2 transition-colors duration-300 sm:w-auto sm:space-x-2 sm:px-4"
    [ngClass]="viewType() === 'list' ? 'text-white' : 'text-gray-700'"
    [attr.aria-pressed]="viewType() === 'list'"
    (click)="toggleView('list')"
  >
    <img
      class="h-3 w-3 transition-opacity duration-300 sm:h-4 sm:w-4"
      [src]="
        viewType() === 'list'
          ? 'assets/icons/list_icon_white.svg'
          : 'assets/icons/list_icon_black.svg'
      "
      [ngClass]="viewType() === 'list' ? 'opacity-100' : 'opacity-50'"
      alt="List view"
    />
    <span class="text-xs sm:text-sm">{{
      'components.toggleView.list' | translate
    }}</span>
  </button>
  <button
    class="relative z-10 flex w-1/2 items-center justify-center space-x-1 rounded-full px-3 py-2 transition-colors duration-300 sm:w-auto sm:space-x-2 sm:px-4"
    [ngClass]="viewType() === 'grid' ? 'text-white' : 'text-gray-700'"
    [attr.aria-pressed]="viewType() === 'grid'"
    (click)="toggleView('grid')"
  >
    <img
      class="h-3 w-3 transition-opacity duration-300 sm:h-4 sm:w-4"
      [src]="
        viewType() === 'grid'
          ? 'assets/icons/grid_icon_white.svg'
          : 'assets/icons/grid_icon_black.svg'
      "
      [ngClass]="viewType() === 'grid' ? 'opacity-100' : 'opacity-50'"
      alt="Grid view"
    />
    <span class="text-xs sm:text-sm">{{
      'components.toggleView.grid' | translate
    }}</span>
  </button>
</div>
